import { TextInput } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SectionTitle } from '../../../../components/text';

interface CurriculumLegendProps {
  legend: any;
}

export const CurriculumLegend = ({ legend }: CurriculumLegendProps) => {
  const { t } = useTranslation();
  const prefix = 'studyPlans.curriculum.legend';

  return (
    <div className="legend-table pb-5">
      <Row>
        <Col xs={12}>
          <SectionTitle text={t(`${prefix}.creditsAndHours`)} />
        </Col>
      </Row>
      <Row className="pb-5">
        <Col xs={12}>
          <span className="fs-18">{t(`${prefix}.creditsAndHoursDesc`)}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3}>
          <TextInput
            name="legendTotalCredits"
            label={t(`${prefix}.totalCredits`)}
            value={legend.total || '0'}
            disabled
          />
        </Col>
      </Row>
      <Row className="pt-3">
        <Col xs={12} md={3}>
          <TextInput
            name="legendTotalHours"
            label={t(`${prefix}.hours`)}
            value={legend.totalHours || '0'}
            disabled
          />
        </Col>
      </Row>
    </div>
  );
};
